module.exports = __webpack_public_path__ + "img/incoming.ec17a82a.svg";